export default "__VITE_ASSET__CZilhzqS__"